import React from 'react'

const GroupAmountSmall = ({ handleUpdateAmount, amount, viewOnly }) => {
    return (
        <div className="update-amount">
            {!viewOnly && (
                <div
                    className="sub"
                    onClick={e => (e.stopPropagation(), handleUpdateAmount(-1))}
                >
                    -
                </div>
            )}
            <div className="amount">{amount}</div>
            {!viewOnly && (
                <div
                    className="add"
                    onClick={e => (e.stopPropagation(), handleUpdateAmount(1))}
                >
                    +
                </div>
            )}
        </div>
    )
}

export default GroupAmountSmall
